module.exports = __webpack_public_path__ + "img/micro-cluster.023d1e64.webp";